import React, {Component} from 'react';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import css from './Settings.module.scss';
import NoticeFeed from "./NoticeFeed/NoticeFeed";
import LeadsAndCustomerFields from "./LeadsAndCustomers/LeadsAndCustomerFields";
import DataFilters from "./DataFilters/DataFilters";
import Users from "./Users/Users";
import SalesForceAccount from "./SalesForceAccount/SalesForceAccount";
import axios from "axios";
import Alert from "../../components/Alert/Alert";


/**
 * @class
 *
 * Settings page.
 * This is container for several sub-components.
 */
const Settings = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    tabList = [
        'Notice Feed',
        'Lead & Customer Fields',
        'Data Filters',
        'Users by Teams',
        'Sales Force Account'
    ];

    // ---------- state: ----------
    state = {
        shouldShowAlert: false,
        activeTab: 'Notice Feed',
        leadFields: {},
        opportunityFields: {},
        // n.b. we need to use bracket-notation rather than dot-notation for all instances of `userData` because child properties are strings with white spaces:
        userData: [],
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        axios.get(
            '/user/contact/all',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    userData: res.data
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    // If we get a server error (400), there's a good chance we need to refresh the API token:
                    if (err.response && err.response.status === 400) {
                        this.setState({ shouldShowAlert: true });
                        setTimeout(() => {
                            this.setState({ shouldShowAlert: false });
                        }, 7500);
                    }
                    console.log('(GET) Error:\n', err);
                }
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    /**
     * @method
     * @methodOf Settings
     *
     * Dynamically renders sub-sections (component) based on active tab on the Settings page.
     * `activeTab` state is changed upon clicking on respective tab.
     *
     * @returns {JSX.Element|null}: Subsection component. E.g. "Notice Feed" view.
     */
    renderContent = () => {
        switch (this.state.activeTab) {
            case 'Notice Feed':
                return <NoticeFeed />;
            case 'Lead & Customer Fields':
                return (
                    <LeadsAndCustomerFields
                        leadFields={this.state.leadFields}
                        opportunityFields={this.state.opportunityFields}
                        leadFieldsOnChange={(val) => this.setState({leadFields: val})}
                        opportunityFieldsOnChange={(val) => this.setState({opportunityFields: val})} />
                    );
            case 'Data Filters':
                return (
                    <DataFilters />
                );
            case 'Users by Teams':
                return <Users userData={this.state.userData} />
            case 'Sales Force Account':
                return <SalesForceAccount userData={this.state.userData} />;
            default:
                return null;
        }
    };

    /**
     * @method
     * @methodOf Settings
     *
     * Sets the active tab state (`activeTab`).
     * Setting the active tab changes displayed content (sub-sections) on the page/view.
     *
     * @param tabName {string}: Name of field to toggle visibility.
     */
    handleSetActiveTabOnClick = (tabName) => {
        this.setState({
            activeTab: tabName
        });
    };

    /**
     * @method
     * @methodOf Settings
     *
     * Dynamically sets tab CSS based on the active tab.
     *
     * @param tabName {string}: Name of field.
     * @returns {string|null}: either CSS module's generated CSS string or null.
     */
    activeTabCss = (tabName) => {
        return this.state.activeTab === tabName ? css.ActiveTab : null;
    };

    render() {
        return (
            <div className={css.Settings}>
                <Alert showAlert={this.state.shouldShowAlert}>Something went wrong. Please refresh your API Token in "Settings" "SalesForce Account".</Alert>
                <SectionHeading heading="Settings" />

                {
                    this.state.userData.length !== 0 ?
                
                    <div className="row">
                        <nav className={`${css.Settings__Nav} col-sm-12 col-md-4 px-0`}>
                            <ul>
                                {
                                    this.tabList.map((tabName) => {
                                        return (
                                            <li
                                                key={tabName}
                                                onClick={() => this.handleSetActiveTabOnClick(tabName)}
                                                className={this.activeTabCss(tabName)}
                                            >{tabName}</li>
                                        );
                                    })
                                }
                            </ul>
                        </nav>
                        <section className={`${css.Settings__Content} col-sm-12 col-md-8 py-3`}>
                            { this.renderContent() }
                        </section>
                    </div>
                    :
                    ''
                }

            </div>
        );
    }
};

export default Settings;
